import { useRef } from "react";
import isEqual from "lodash/isEqual";

/**
 * Like useMemo, but recomputes only when deps are deep-equal to the previous run.
 */
export function useDeepCompareMemo(factory, deps) {
  const valueRef = useRef(null);
  const depsRef = useRef(null);
  let recompute = depsRef.current == null || depsRef.current.length !== deps.length;
  if (!recompute) {
    for (let i = 0; i < deps.length; i++) {
      if (!isEqual(deps[i], depsRef.current[i])) {
        recompute = true;
        break;
      }
    }
  }
  if (recompute) {
    depsRef.current = deps;
    valueRef.current = factory();
  }
  return valueRef.current;
}
